// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3n8Bj","legacyBtn":"MutateMid_legacyBtn__1MFO2"};